import React from "react";
import {Link} from "react-router-dom";
import logo from '../logo.svg';

interface Props {

}

export default class Footer extends React.Component<Props, any> {
    render() {
        return <>
            <div className="container-fluid text-bg-dark my-0 py-0">
                <footer className="container d-flex flex-wrap justify-content-between align-items-center py-5">
                    <p className="col-md-4 text-white mb-3">Могилёвский государственный университет имени А. А. Кулешова © 2024. Все права защищены.</p>
                    <Link to="/"
                          className="col-md d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none">
                        <img src={logo} className="logo"/>
                    </Link>

                    <div className="col-md-5 mb-0 text-white d-flex">
                        <p className="text-white mb-3">
                            Понедельник – четверг 8.30 – 17.30<br/>
                            Пятница 8.30 – 16.15<br/>
                            Суббота, воскресенье выходной<br/>
                            Перерыв:<br/>
                            Понедельник – пятница 13.00 – 13.45<br/>
                        </p>

                        <ul className="col-md-auto list-unstyled">
                            <li className="">
                                <p className="m-0 pt-2" aria-expanded="false">
                                    <i className="bi bi-telephone-fill"></i>
                                    +375291800508
                                </p>
                            </li>
                            <li className="">
                                <p className="m-0 pt-2" aria-expanded="false">
                                    <i className="bi bi-envelope-fill"></i>
                                    confucius@m.msu.by
                                </p>
                            </li>
                        </ul>
                    </div>
                </footer>
            </div>
        </>;
    }
}